export const MEXICO_CITY_TIME_ZONE = 'America/Mexico_City';

export const getMexicoCityDateParts = (value = new Date()) => {
  return new Intl.DateTimeFormat('en-CA', {
    timeZone: MEXICO_CITY_TIME_ZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).formatToParts(value).reduce((acc, part) => {
    acc[part.type] = part.value;
    return acc;
  }, {});
};

export const getMexicoCityDateTimeParts = (value = new Date()) => {
  return new Intl.DateTimeFormat('en-CA', {
    timeZone: MEXICO_CITY_TIME_ZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
    hourCycle: 'h23',
  }).formatToParts(value).reduce((acc, part) => {
    acc[part.type] = part.value;
    return acc;
  }, {});
};

export const mexicoCityToday = () => {
  const parts = getMexicoCityDateParts();
  return `${parts.year}-${parts.month}-${parts.day}`;
};

export const mexicoCityNowDateTimeLocal = () => {
  const parts = getMexicoCityDateTimeParts();
  return `${parts.year}-${parts.month}-${parts.day}T${parts.hour}:${parts.minute}`;
};

export const mexicoCityNowTime = () => {
  const parts = getMexicoCityDateTimeParts();
  return `${parts.hour}:${parts.minute}`;
};

export const parseDateOnlyAsMexicoCityDate = (dateString) => {
  if (!dateString) {
    return null;
  }
  const [year, month, day] = dateString.split('-').map(Number);
  return new Date(year, month - 1, day);
};
